import { createFileRoute, redirect } from '@tanstack/react-router';
import { DEFAULT_SUPPORT_TAB } from '@/components/support/support-page';

/** `/support` names no tab, so it opens the board. */
export const Route = createFileRoute('/support/')({
  beforeLoad: () => {
    throw redirect({ to: '/support/$tab', params: { tab: DEFAULT_SUPPORT_TAB } });
  },
});
